/* A path back, one line, between the context bar and the screen. Tokens only (ADR-0007).

   Quieter than the bar above it: the parents are links in the accent, the separator is a hairline
   glyph, and the current screen is the one word in full ink, so the eye lands on where you are
   rather than on the way back. */

.nav {
  flex: 0 0 auto;
  padding: 5px 16px;
  font-size: var(--t-min);
  line-height: 18px;
  color: var(--muted);
  background: var(--panel);
  border-bottom: 1px solid var(--line);
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.item {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

.item[aria-current="page"] {
  color: var(--ink);
  font-weight: 600;
}

/* The separator is generated, so it is not read out and not selected with the text. */
.item + .item::before {
  color: var(--line-2);
  content: "/";
}

.link {
  display: inline-flex;
  align-items: center;
  min-height: var(--target-min);
  color: var(--accent);
  text-decoration: none;
  border-radius: 3px;
}

.link:hover {
  color: var(--accent-h);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.link:active {
  color: var(--ink);
}
